// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { createTheme } from '@mui/material/styles';
import { createThemeOption } from '@aurora/ui/aurora-design-system/src';
var themeMode = 'light';
export var theme = createTheme(createThemeOption(themeMode));

//# sourceMappingURL=theme.js.map